// Others
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import axiosClient from './axiosClient';
import { IBodyUpdate } from '~/utils/interface/common';
import { urlApiEquipment } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IEquipment, IEquipmentDetail, IFormEquipment, IQueryParamEquipment } from '~/utils/interface/equipment';

const equipmentApi = {
  getListEquipment: (params: IQueryParamEquipment) => {
    const url = urlApiEquipment.getListEquipment;
    return axiosClient.get<IBaseResponse<IListDataResponse<IEquipment[]>>>(url, { params });
  },

  getDetailEquipment: (id: string) => {
    const url = urlApiEquipment.getDetailEquipment(id);
    return axiosClient.get<IBaseResponse<IEquipmentDetail>>(url);
  },

  createEquipment: (body: IFormEquipment) => {
    const url = urlApiEquipment.createEquipment;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateEquipment: (params: IBodyUpdate<IFormEquipment>) => {
    const { id, body } = params;
    const url = urlApiEquipment.updateEquipment(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteEquipment: (id: string) => {
    const url = urlApiEquipment.deleteEquipment(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default equipmentApi;
